export const getIsInitialActivitySetPollLoading = (state) => {
  return !!state.recentActivitySetsPoll.isInitialPollLoading;
};
